export default __webpack_public_path__ + "static/media/Legacy-Plus-Brochure.34677a87.pdf";